import * as angular from "angular";
import { FileUploaderFactory, FileUploader } from "angular-file-upload";
import Croppie from "croppie";
import { CredentialsManager } from "../../shared/credentials-manager";
import { ToastUtils } from "../../helper/toast.helper";

let CoverPhotoComponent = {
    selector: "vcCoverPhoto",
    templateUrl: "/angular/components/event/cover-photo.component.html",
    bindings: {
        eventImage: "=?",
        imageUpload: "=?",
        onChange: "&?",
        onSaved: "&?",
    },
    controller: class CoverPhotoController {
        // * bindings for typescript compiler *
        public eventImage?: any;
        public imageUpload?: any;
        public onChange?: any;
        public onSaved?: any;
        // ************************************

        public timeoutCode: any;
        public croppie: any = null;
        public uploader: FileUploader;
        public imgLoading = false;

        private $scope: any;
        private $timeout: any;
        private toast: ToastUtils;

        constructor(
            $scope: any,
            $timeout: any,
            ToastUtils: ToastUtils,
            FileUploader: FileUploaderFactory,
            CredentialsManager: CredentialsManager
        ) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.toast = ToastUtils;

            this.uploader = new FileUploader({
                headers: {
                    Authorization:
                        "Bearer " + CredentialsManager.getAccessToken(),
                } as any,
                autoUpload: true,
                removeAfterUpload: true,
            });

            setTimeout(() => {
                angular
                    .element(document.querySelector("#cover-image-upload"))
                    .on("change", this.handleFileSelect.bind(this));
            }, 200);

            setTimeout(() => {
                angular
                    .element(document.querySelector("#cover-image-change"))
                    .on("change", this.handleFileSelect.bind(this));
            }, 200);
        }

        $onInit() {
            if (this.eventImage) {
                this.imageUpload = angular.copy(this.eventImage);
            }
        }

        handleFileSelect(event: any): void {
            const file = event.currentTarget.files[0];

            if (file) {
                this.onChange && this.onChange();
                this.destroy();
                this.imgLoading = true;
                let reader = new FileReader();
                let imageType = /image.*/;

                setTimeout(() => {
                    if (file.type.match(imageType)) {
                        this.destroy();
                        reader.onload = (evt: any) => {
                            this.$scope.$apply(($scope: any) => {
                                this.eventImage = evt.target.result;
                            });
                        };
                        reader.readAsDataURL(file);

                        setTimeout(() => {
                            this.initCropper();
                        }, 150);
                    } else {
                        this.toast.error("File not supported");
                    }
                }, 150);
            }
        }

        initCropper(): void {
            let img = document.getElementById("image-preview");
            this.croppie = new Croppie(img, {
                enableExif: true,
                viewport: {
                    width: 513,
                    height: 270,
                },
                showZoomer: true,
                update: () => {
                    this.savePhoto();
                },
            });
        }

        destroy(): void {
            this.eventImage = null;
            this.imageUpload = null;
            if (!this.croppie) return;

            this.croppie.destroy();
            this.croppie = null;
            this.onSaved && this.onSaved({ image: null });
        }

        savePhoto(): void {
            this.croppie
                .result({
                    type: "canvas",
                    size: { width: "513", height: "270" },
                })
                .then((image: any) => {
                    this.$timeout.cancel(this.timeoutCode);

                    this.timeoutCode = this.$timeout(() => {
                        this.imageUpload = image;
                        this.onSaved && this.onSaved({ image: image });
                    }, 200);
                });
        }
    },
};

angular
    .module("event", [])
    .component(CoverPhotoComponent.selector, CoverPhotoComponent);
